export default __webpack_public_path__ + "static/media/tapabocas.2995fa3f.png";